import { createGlobalStyle } from 'styled-components';
import tw from 'tailwind.macro';

export default createGlobalStyle`
  body {
    ${tw`m-0 text-indigo-900 bg-white`};
  }

  a {
    ${tw`text-blue-900 hover:text-blue-400 underline`};    
  }

  p + p {
    ${tw`mt-3`};
  }

  h2 {
    ${tw`mt-12 mx-0 mb-0 text-4xl`};
    font-weight: bold;
  }

  h3 {
    ${tw`mt-4 mx-0 mb-0 text-xl`};
    font-weight: bold;
  }

  ul {
    list-style: disc;
    ${tw`ml-4 my-4`}
  }

  p code {
    ${tw`font-mono text-blue-500`};
  }
`;
